export const inquiryTypes = [
    { value: 'professional', label: 'Professional enquiry', hint: 'Bookings, performances, commissions and business' },
    { value: 'collaboration', label: 'Collaboration', hint: 'Music, poetry, film and visual projects together' },
    { value: 'media', label: 'Media & press', hint: 'Interviews, features, reviews and press material' },
    { value: 'licensing', label: 'Licensing', hint: 'Using a song in film, advertising, games or other work' },
    { value: 'general', label: 'Something else', hint: 'A note, a question, or simply hello' }
] as const

export type InquiryType = typeof inquiryTypes[number]['value']

export const inquiryLabel = (value: string): string => inquiryTypes.find(type => type.value === value)?.label ?? 'Message'
